var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { ActionsTitle, MainTitle, SendProjectButton } from './styles';
import { NoProjectWrapper, ProjectTabItem, TagsSearchModalContainer, TagsSearchModalWrapper } from '../CardSelectModal/styles';
import { useProjectsList } from '../../../hooks/api/useProjectsByFilter';
import useLocalization from '../../../hooks/useLocalization';
import { useProfile } from '@brg/auth';
import { ProjectsSearchBar } from '../../projectsSearchBar/projectsSearchBar';
import ProjectCardNew from '../../projectCard/projectCardNew';
import { ProjectsGridNew } from '../../grids';
import { LayoutConst } from '../../../constants/media';
import styled from 'styled-components';
import { Pagination } from "../../pagination";
import { DropdownTabs } from "./DropdownTabs";
import { SearchInputComponent } from "./SearchInput/SearchInputComponent";
var ProjectSendModalContainer = styled(TagsSearchModalContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1157px;\n  overflow-x: hidden;\n  //max-height: calc(100% - 100px);\n\n  @media (max-width: ", "px) {\n    width: 893px;\n  }\n"], ["\n  width: 1157px;\n  overflow-x: hidden;\n  //max-height: calc(100% - 100px);\n\n  @media (max-width: ", "px) {\n    width: 893px;\n  }\n"])), LayoutConst.container.mac13);
export var NeedProject = function (_a) {
    var isPresentation = _a.isPresentation;
    var isMobile = useIsMobile();
    return (React.createElement(TagsSearchModalWrapper, { isWhite: true },
        React.createElement(ProjectSendModalContainer, { isCenterModal: true },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', width: '100%', justify: 'center', align: 'center' },
                React.createElement(FInter.TextDiv, { color: '#000000', style: {
                        fontSize: isMobile ? '20px' : '43px',
                        lineHeight: isMobile ? '25px' : '51px'
                    } }, "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432!"),
                React.createElement(FInter.TextFlex, { color: Colors.galBlack100, justify: 'center', offsetTop: 16, style: {
                        textAlign: 'center',
                        maxWidth: isMobile ? '237px' : '815px',
                        fontSize: isMobile ? '13px' : '30px',
                        lineHeight: isMobile ? '18px' : '40px'
                    } }, "\u0414\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442."),
                !isPresentation && React.createElement(FlexBox, { offsetTop: 40 },
                    React.createElement(SendProjectButton, { onClick: function () { return (window.location.href = '/edit'); } }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442"))))));
};
var ProjectsScroller = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-y: auto;\n  height: ", ";\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #909090;\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n"], ["\n  overflow-y: auto;\n  height: ", ";\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #909090;\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? 'auto' : '50vh';
}, function (_a) {
    var theme = _a.theme;
    return theme.cardsEmptyModal.bg;
});
var SEND_PROJECT_TABS;
(function (SEND_PROJECT_TABS) {
    SEND_PROJECT_TABS["projects"] = "projects";
    SEND_PROJECT_TABS["presentations"] = "presentations";
    SEND_PROJECT_TABS["bookmarks"] = "bookmarks";
    SEND_PROJECT_TABS["find_projects"] = "find_projects";
    SEND_PROJECT_TABS["selected_projects"] = "selected_projects";
})(SEND_PROJECT_TABS || (SEND_PROJECT_TABS = {}));
var SendProjectModal = function (_a) {
    var _b, _c, _d;
    var _e = _a.alreadyProjects, alreadyProjects = _e === void 0 ? [] : _e, onSelectProjects = _a.onSelectProjects, _f = _a.maxProjects, maxProjects = _f === void 0 ? 2 : _f, teamContexts = _a.teamContexts, teamExtraFilter = _a.teamExtraFilter;
    var profile = useProfile();
    var _g = useState(new Date().getTime()), time = _g[0], setT = _g[1];
    // @ts-ignore
    var _h = useLocalization(), t = _h.t, language = _h.language;
    var _j = useState(1), sorting = _j[0], setSorting = _j[1];
    var _k = useState(''), searchText = _k[0], setSearchText = _k[1];
    var _l = useState(SEND_PROJECT_TABS.projects), activeTab = _l[0], setActiveTab = _l[1];
    var toasts = useToasts();
    var isMobile = useIsMobile();
    var _m = useState(null), filterOpt = _m[0], setFilterOpt = _m[1];
    var _o = useState(alreadyProjects), selectedProjects = _o[0], setSelectedProjects = _o[1];
    var _p = useState(1), currentPage = _p[0], setPage = _p[1];
    var onPageChange = useCallback(function (page) {
        setPage(page);
        setFilterOpt(null);
        setT(Date.now());
    }, []);
    var onSend = useCallback(function () { return onSelectProjects && onSelectProjects(selectedProjects); }, [onSelectProjects, selectedProjects]);
    var is1440BP = useBreakpoint(LayoutConst.container.mac13);
    var scrollTop = function () { return window.scrollTo(0, 0); };
    var searchedId = useMemo(function () {
        var splittedText = searchText === null || searchText === void 0 ? void 0 : searchText.split('/');
        return (splittedText === null || splittedText === void 0 ? void 0 : splittedText.length) > 0 ? splittedText[(splittedText === null || splittedText === void 0 ? void 0 : splittedText.length) - 1] : '';
    }, [searchText]);
    var noSelectedProjects = useMemo(function () { return (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 && activeTab === SEND_PROJECT_TABS.selected_projects; }, [searchText, activeTab]);
    var noFindProjects = useMemo(function () { return !searchedId && activeTab === SEND_PROJECT_TABS.find_projects; }, [searchedId, activeTab]);
    var _q = useProjectsList(filterOpt, language, time, filterOpt === null
        || noSelectedProjects
        || noFindProjects), projects = _q[0], isProjectsLoading = _q[1], projectsPaging = _q[3];
    useEffect(function () {
        var _a, _b;
        if (profile && (profile === null || profile === void 0 ? void 0 : profile.accountId)) {
            var baseFilters = {
                projectFilter: sorting,
                page: currentPage,
                limit: 8,
                projectStatus: [1, 7],
                isContextIgnored: true,
                contextsNotContains: ['lmsproject', 'lmshseproject']
            };
            var defaultFilters = __assign(__assign({}, baseFilters), { projectFilter: sorting, isContextIgnored: true, onlyAuthors: false, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks });
            if (teamExtraFilter)
                defaultFilters = __assign(__assign(__assign({}, defaultFilters), { isContextIgnored: false }), teamExtraFilter);
            else if (((_a = (teamContexts || [])) === null || _a === void 0 ? void 0 : _a.length) > 0)
                defaultFilters = __assign(__assign({}, defaultFilters), { contexts: teamContexts, isContextIgnored: false });
            if (activeTab === SEND_PROJECT_TABS.bookmarks)
                defaultFilters = __assign(__assign({}, defaultFilters), { onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks });
            if (activeTab === SEND_PROJECT_TABS.projects)
                defaultFilters = __assign(__assign({}, defaultFilters), { excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'] });
            if (activeTab === SEND_PROJECT_TABS.presentations)
                defaultFilters = __assign(__assign({}, defaultFilters), { projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'] });
            if (activeTab === SEND_PROJECT_TABS.selected_projects)
                defaultFilters = { projectIds: selectedProjects };
            if (activeTab === SEND_PROJECT_TABS.find_projects)
                defaultFilters = { projectFilter: sorting, page: currentPage, limit: 8, isContextIgnored: true, projectIds: [searchedId] };
            // projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'],
            // contextsNotContains: ['lmsproject', 'lmshseproject']
            setFilterOpt((activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects) ? defaultFilters : teamExtraFilter
                ? __assign(__assign(__assign({}, defaultFilters), { isContextIgnored: false }), teamExtraFilter) : (((_b = (teamContexts || [])) === null || _b === void 0 ? void 0 : _b.length) > 0
                ? __assign(__assign({}, defaultFilters), { contexts: teamContexts, isContextIgnored: false }) : __assign(__assign({}, defaultFilters), { authorOrCoAuthorOrCuratorIds: [profile === null || profile === void 0 ? void 0 : profile.accountId] })));
        }
    }, [profile, sorting, currentPage, teamContexts, teamExtraFilter, activeTab, searchedId]);
    useEffect(function () {
        setT(Date.now());
    }, [activeTab, searchedId]);
    var onSortingChange = useCallback(function (s) {
        setSorting(s);
        setT(Date.now());
    }, []);
    var onSelect = useCallback(function (projectId, isPresentation) {
        if (isPresentation) {
            setSelectedProjects([projectId]);
            return;
        }
        setSelectedProjects(function (prev) {
            if (prev.includes(projectId))
                return prev.filter(function (a) { return a !== projectId; });
            if ((prev === null || prev === void 0 ? void 0 : prev.length) > (maxProjects - 1)) {
                toasts.error(t('competition.max_error') + ' ' + maxProjects);
                return prev;
            }
            return __spreadArray(__spreadArray([], prev, true), [projectId], false);
        });
    }, [setSelectedProjects, maxProjects]);
    var searchBar = useMemo(function () {
        var _a;
        return (React.createElement(ProjectsSearchBar, { isLoading: false, 
            // categoryValue={categoryValue}
            // categories={categories.filter((v) => v?.groupType?.toLowerCase() === 'dafes')}
            sorting: sorting, hideRightBar: false, hideLeftBar: true, hideRightButtons: true, onSortingChange: onSortingChange, isTagPage: false, projectCount: (_a = projects === null || projects === void 0 ? void 0 : projects.data) === null || _a === void 0 ? void 0 : _a.length }));
    }, [sorting, onSortingChange, projects]);
    var tabNames = useMemo(function () {
        var _a, _b, _c;
        var extraTabs = (teamExtraFilter ? (_a = {},
            _a[SEND_PROJECT_TABS.bookmarks] = t('send_projects.bookmarks'),
            _a[SEND_PROJECT_TABS.find_projects] = t('send_projects.find_projects'),
            _a) : {});
        return (__assign(__assign((_b = {}, _b[SEND_PROJECT_TABS.projects] = t('send_projects.projects'), _b[SEND_PROJECT_TABS.presentations] = t('send_projects.presentations'), _b), extraTabs), (_c = {}, _c[SEND_PROJECT_TABS.selected_projects] = t('send_projects.selected_projects') + ' ' + (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) || 0, _c)));
    }, [selectedProjects, teamExtraFilter, language]);
    var MobileDropdownTabs = useMemo(function () {
        var _a, _b, _c;
        var extraTabs = (teamExtraFilter ? (_a = {},
            _a[SEND_PROJECT_TABS.bookmarks] = tabNames[SEND_PROJECT_TABS.bookmarks],
            _a[SEND_PROJECT_TABS.find_projects] = tabNames[SEND_PROJECT_TABS.find_projects],
            _a) : {});
        t('send_projects.bookmarks');
        t('send_projects.find_projects');
        t('send_projects.projects');
        t('send_projects.presentations');
        t('send_projects.selected_projects');
        return (React.createElement(DropdownTabs, { whiteTheme: false, activeTabKey: activeTab, items: __assign(__assign((_b = {}, _b[SEND_PROJECT_TABS.projects] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.projects]), _b[SEND_PROJECT_TABS.presentations] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.presentations]), _b), extraTabs), (_c = {}, _c[SEND_PROJECT_TABS.selected_projects] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.selected_projects]), _c)), onChange: function (tab) {
                setActiveTab(tab);
            } }));
    }, [activeTab, tabNames, teamExtraFilter, language]);
    // if (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data)) return <NeedProject isPresentation={isPresentation}/>
    var isNoProjects = useMemo(function () {
        var _a;
        return (!isProjectsLoading && (((_a = projects === null || projects === void 0 ? void 0 : projects.data) === null || _a === void 0 ? void 0 : _a.length) === 0 || !(projects === null || projects === void 0 ? void 0 : projects.data))
            || ((selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 && activeTab === SEND_PROJECT_TABS.selected_projects)
            || noSelectedProjects || noFindProjects);
    }, [!isProjectsLoading, projects, selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length, noSelectedProjects, noFindProjects]);
    return (React.createElement(TagsSearchModalWrapper, { isWhite: true, autoScroll: true },
        React.createElement(ProjectSendModalContainer, null,
            React.createElement(ActionsTitle, { justify: 'space-between', justifyMobile: 'space-between', direction: 'row' },
                React.createElement(FlexBox, { direction: 'row' },
                    React.createElement(MainTitle, null, t('competition.select_project'))),
                React.createElement(FlexBox, null,
                    React.createElement(SendProjectButton, { width: 187, disabled: (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 || (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) > maxProjects, onClick: onSend }, t('competition.send')))),
            React.createElement(FlexBox, { width: '100%', direction: 'row', justify: 'space-between', align: 'center', offsetBottom: is1440BP ? 24 : 32 },
                isMobile ? MobileDropdownTabs : React.createElement(FlexBox, { gx: 24 }, Object.values(SEND_PROJECT_TABS).map(function (tab, index) { return React.createElement(ProjectTabItem, { isActive: activeTab == tab, key: index, onClick: function () { return setActiveTab(tab); } }, tabNames[tab]); })),
                searchBar),
            activeTab === SEND_PROJECT_TABS.find_projects && React.createElement(FlexBox, { width: "100%", offsetBottom: 24 },
                React.createElement(SearchInputComponent, { setSearchText: setSearchText, searchText: searchText, placeholder: "Введите ссылку на проект" })),
            isNoProjects ? React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(") : React.createElement(React.Fragment, null,
                React.createElement(ProjectsScroller, { isMobile: isMobile },
                    React.createElement(ProjectsGridNew, { isLoading: isProjectsLoading, columns: 4 }, (_b = projects === null || projects === void 0 ? void 0 : projects.data) === null || _b === void 0 ? void 0 : _b.map(function (v) {
                        var _a;
                        return (React.createElement(ProjectCardNew
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            project: v, identifier: v === null || v === void 0 ? void 0 : v.projectId, isModal: true, withoutGoToProject: true, isSelectable: true, key: v === null || v === void 0 ? void 0 : v.projectId, onSelect: onSelect, onProjectClick: undefined, metaAlwaysVisible: true, selected: selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.includes((_a = v === null || v === void 0 ? void 0 : v.projectId) !== null && _a !== void 0 ? _a : '') }));
                    }))),
                React.createElement(Pagination, { pages: (_c = projectsPaging === null || projectsPaging === void 0 ? void 0 : projectsPaging.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                        // @ts-ignore
                        onPageChange(page);
                        setT(Date.now());
                        scrollTop();
                    }, isCanLoadMore: currentPage < ((_d = projectsPaging === null || projectsPaging === void 0 ? void 0 : projectsPaging.pages) !== null && _d !== void 0 ? _d : 0) })))));
};
export default SendProjectModal;
var templateObject_1, templateObject_2;
//# sourceMappingURL=SendProjectModal.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { ActionsTitle, MainTitle, SendProjectButton } from './styles';
import { NoProjectWrapper, ProjectTabItem, TagsSearchModalContainer, TagsSearchModalWrapper } from '../CardSelectModal/styles';
import { useProjectsList } from '../../../hooks/api/useProjectsByFilter';
import useLocalization from '../../../hooks/useLocalization';
import { useProfile } from '@brg/auth';
import { ProjectsSearchBar } from '../../projectsSearchBar/projectsSearchBar';
import ProjectCardNew from '../../projectCard/projectCardNew';
import { ProjectsGridNew } from '../../grids';
import { LayoutConst } from '../../../constants/media';
import styled from 'styled-components';
import { Pagination } from "../../pagination";
import { DropdownTabs } from "./DropdownTabs";
import { SearchInputComponent } from "./SearchInput/SearchInputComponent";
var ProjectSendModalContainer = styled(TagsSearchModalContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1157px;\n  overflow-x: hidden;\n  //max-height: calc(100% - 100px);\n\n  @media (max-width: ", "px) {\n    width: 893px;\n  }\n"], ["\n  width: 1157px;\n  overflow-x: hidden;\n  //max-height: calc(100% - 100px);\n\n  @media (max-width: ", "px) {\n    width: 893px;\n  }\n"])), LayoutConst.container.mac13);
export var NeedProject = function (_a) {
    var isPresentation = _a.isPresentation;
    var isMobile = useIsMobile();
    return (React.createElement(TagsSearchModalWrapper, { isWhite: true },
        React.createElement(ProjectSendModalContainer, { isCenterModal: true },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', width: '100%', justify: 'center', align: 'center' },
                React.createElement(FInter.TextDiv, { color: '#000000', style: {
                        fontSize: isMobile ? '20px' : '43px',
                        lineHeight: isMobile ? '25px' : '51px'
                    } }, "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432!"),
                React.createElement(FInter.TextFlex, { color: Colors.galBlack100, justify: 'center', offsetTop: 16, style: {
                        textAlign: 'center',
                        maxWidth: isMobile ? '237px' : '815px',
                        fontSize: isMobile ? '13px' : '30px',
                        lineHeight: isMobile ? '18px' : '40px'
                    } }, "\u0414\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442."),
                !isPresentation && React.createElement(FlexBox, { offsetTop: 40 },
                    React.createElement(SendProjectButton, { onClick: function () { return (window.location.href = '/edit'); } }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442"))))));
};
var ProjectsScroller = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-y: auto;\n  height: ", ";\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #909090;\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n"], ["\n  overflow-y: auto;\n  height: ", ";\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #909090;\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? 'auto' : '50vh';
}, function (_a) {
    var theme = _a.theme;
    return theme.cardsEmptyModal.bg;
});
var SEND_PROJECT_TABS;
(function (SEND_PROJECT_TABS) {
    SEND_PROJECT_TABS["projects"] = "projects";
    SEND_PROJECT_TABS["presentations"] = "presentations";
    SEND_PROJECT_TABS["bookmarks"] = "bookmarks";
    SEND_PROJECT_TABS["find_projects"] = "find_projects";
    SEND_PROJECT_TABS["selected_projects"] = "selected_projects";
})(SEND_PROJECT_TABS || (SEND_PROJECT_TABS = {}));
var SendProjectModal = function (_a) {
    var _b, _c, _d;
    var _e = _a.alreadyProjects, alreadyProjects = _e === void 0 ? [] : _e, onSelectProjects = _a.onSelectProjects, _f = _a.maxProjects, maxProjects = _f === void 0 ? 2 : _f, teamContexts = _a.teamContexts, teamExtraFilter = _a.teamExtraFilter;
    var profile = useProfile();
    var _g = useState(new Date().getTime()), time = _g[0], setT = _g[1];
    // @ts-ignore
    var _h = useLocalization(), t = _h.t, language = _h.language;
    var _j = useState(1), sorting = _j[0], setSorting = _j[1];
    var _k = useState(''), searchText = _k[0], setSearchText = _k[1];
    var _l = useState(SEND_PROJECT_TABS.projects), activeTab = _l[0], setActiveTab = _l[1];
    var toasts = useToasts();
    var isMobile = useIsMobile();
    var _m = useState(null), filterOpt = _m[0], setFilterOpt = _m[1];
    var _o = useState(alreadyProjects), selectedProjects = _o[0], setSelectedProjects = _o[1];
    var _p = useState(1), currentPage = _p[0], setPage = _p[1];
    var onPageChange = useCallback(function (page) {
        setPage(page);
        setFilterOpt(null);
        setT(Date.now());
    }, []);
    var onSend = useCallback(function () { return onSelectProjects && onSelectProjects(selectedProjects); }, [onSelectProjects, selectedProjects]);
    var is1440BP = useBreakpoint(LayoutConst.container.mac13);
    var scrollTop = function () { return window.scrollTo(0, 0); };
    var searchedId = useMemo(function () {
        var splittedText = searchText === null || searchText === void 0 ? void 0 : searchText.split('/');
        return (splittedText === null || splittedText === void 0 ? void 0 : splittedText.length) > 0 ? splittedText[(splittedText === null || splittedText === void 0 ? void 0 : splittedText.length) - 1] : '';
    }, [searchText]);
    var noSelectedProjects = useMemo(function () { return (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 && activeTab === SEND_PROJECT_TABS.selected_projects; }, [searchText, activeTab]);
    var noFindProjects = useMemo(function () { return !searchedId && activeTab === SEND_PROJECT_TABS.find_projects; }, [searchedId, activeTab]);
    var _q = useProjectsList(filterOpt, language, time, filterOpt === null
        || noSelectedProjects
        || noFindProjects), projects = _q[0], isProjectsLoading = _q[1], projectsPaging = _q[3];
    useEffect(function () {
        var _a, _b;
        if (profile && (profile === null || profile === void 0 ? void 0 : profile.accountId)) {
            var baseFilters = {
                projectFilter: sorting,
                page: currentPage,
                limit: 8,
                projectStatus: [1, 7],
                isContextIgnored: true,
                contextsNotContains: ['lmsproject', 'lmshseproject']
            };
            var defaultFilters = __assign(__assign({}, baseFilters), { projectFilter: sorting, isContextIgnored: true, onlyAuthors: false, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks });
            if (teamExtraFilter)
                defaultFilters = __assign(__assign(__assign({}, defaultFilters), { isContextIgnored: false }), teamExtraFilter);
            else if (((_a = (teamContexts || [])) === null || _a === void 0 ? void 0 : _a.length) > 0)
                defaultFilters = __assign(__assign({}, defaultFilters), { contexts: teamContexts, isContextIgnored: false });
            if (activeTab === SEND_PROJECT_TABS.bookmarks)
                defaultFilters = __assign(__assign({}, defaultFilters), { onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks });
            if (activeTab === SEND_PROJECT_TABS.projects)
                defaultFilters = __assign(__assign({}, defaultFilters), { excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'] });
            if (activeTab === SEND_PROJECT_TABS.presentations)
                defaultFilters = __assign(__assign({}, defaultFilters), { projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'] });
            if (activeTab === SEND_PROJECT_TABS.selected_projects)
                defaultFilters = { projectIds: selectedProjects };
            if (activeTab === SEND_PROJECT_TABS.find_projects)
                defaultFilters = { projectFilter: sorting, page: currentPage, limit: 8, isContextIgnored: true, projectIds: [searchedId] };
            // projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'],
            // contextsNotContains: ['lmsproject', 'lmshseproject']
            setFilterOpt((activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects) ? defaultFilters : teamExtraFilter
                ? __assign(__assign(__assign({}, defaultFilters), { isContextIgnored: false }), teamExtraFilter) : (((_b = (teamContexts || [])) === null || _b === void 0 ? void 0 : _b.length) > 0
                ? __assign(__assign({}, defaultFilters), { contexts: teamContexts, isContextIgnored: false }) : __assign(__assign({}, defaultFilters), { authorOrCoAuthorOrCuratorIds: [profile === null || profile === void 0 ? void 0 : profile.accountId] })));
        }
    }, [profile, sorting, currentPage, teamContexts, teamExtraFilter, activeTab, searchedId]);
    useEffect(function () {
        setT(Date.now());
    }, [activeTab, searchedId]);
    var onSortingChange = useCallback(function (s) {
        setSorting(s);
        setT(Date.now());
    }, []);
    var onSelect = useCallback(function (projectId, isPresentation) {
        if (isPresentation) {
            setSelectedProjects([projectId]);
            return;
        }
        setSelectedProjects(function (prev) {
            if (prev.includes(projectId))
                return prev.filter(function (a) { return a !== projectId; });
            if ((prev === null || prev === void 0 ? void 0 : prev.length) > (maxProjects - 1)) {
                toasts.error(t('competition.max_error') + ' ' + maxProjects);
                return prev;
            }
            return __spreadArray(__spreadArray([], prev, true), [projectId], false);
        });
    }, [setSelectedProjects, maxProjects]);
    var searchBar = useMemo(function () {
        var _a;
        return (React.createElement(ProjectsSearchBar, { isLoading: false, 
            // categoryValue={categoryValue}
            // categories={categories.filter((v) => v?.groupType?.toLowerCase() === 'dafes')}
            sorting: sorting, hideRightBar: false, hideLeftBar: true, hideRightButtons: true, onSortingChange: onSortingChange, isTagPage: false, projectCount: (_a = projects === null || projects === void 0 ? void 0 : projects.data) === null || _a === void 0 ? void 0 : _a.length }));
    }, [sorting, onSortingChange, projects]);
    var tabNames = useMemo(function () {
        var _a, _b, _c;
        var extraTabs = (teamExtraFilter ? (_a = {},
            _a[SEND_PROJECT_TABS.bookmarks] = t('send_projects.bookmarks'),
            _a[SEND_PROJECT_TABS.find_projects] = t('send_projects.find_projects'),
            _a) : {});
        return (__assign(__assign((_b = {}, _b[SEND_PROJECT_TABS.projects] = t('send_projects.projects'), _b[SEND_PROJECT_TABS.presentations] = t('send_projects.presentations'), _b), extraTabs), (_c = {}, _c[SEND_PROJECT_TABS.selected_projects] = t('send_projects.selected_projects') + ' ' + (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) || 0, _c)));
    }, [selectedProjects, teamExtraFilter, language]);
    var MobileDropdownTabs = useMemo(function () {
        var _a, _b, _c;
        var extraTabs = (teamExtraFilter ? (_a = {},
            _a[SEND_PROJECT_TABS.bookmarks] = tabNames[SEND_PROJECT_TABS.bookmarks],
            _a[SEND_PROJECT_TABS.find_projects] = tabNames[SEND_PROJECT_TABS.find_projects],
            _a) : {});
        t('send_projects.bookmarks');
        t('send_projects.find_projects');
        t('send_projects.projects');
        t('send_projects.presentations');
        t('send_projects.selected_projects');
        return (React.createElement(DropdownTabs, { whiteTheme: false, activeTabKey: activeTab, items: __assign(__assign((_b = {}, _b[SEND_PROJECT_TABS.projects] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.projects]), _b[SEND_PROJECT_TABS.presentations] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.presentations]), _b), extraTabs), (_c = {}, _c[SEND_PROJECT_TABS.selected_projects] = t('send_projects.' + tabNames[SEND_PROJECT_TABS.selected_projects]), _c)), onChange: function (tab) {
                setActiveTab(tab);
            } }));
    }, [activeTab, tabNames, teamExtraFilter, language]);
    // if (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data)) return <NeedProject isPresentation={isPresentation}/>
    var isNoProjects = useMemo(function () {
        var _a;
        return (!isProjectsLoading && (((_a = projects === null || projects === void 0 ? void 0 : projects.data) === null || _a === void 0 ? void 0 : _a.length) === 0 || !(projects === null || projects === void 0 ? void 0 : projects.data))
            || ((selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 && activeTab === SEND_PROJECT_TABS.selected_projects)
            || noSelectedProjects || noFindProjects);
    }, [!isProjectsLoading, projects, selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length, noSelectedProjects, noFindProjects]);
    return (React.createElement(TagsSearchModalWrapper, { isWhite: true, autoScroll: true },
        React.createElement(ProjectSendModalContainer, null,
            React.createElement(ActionsTitle, { justify: 'space-between', justifyMobile: 'space-between', direction: 'row' },
                React.createElement(FlexBox, { direction: 'row' },
                    React.createElement(MainTitle, null, t('competition.select_project'))),
                React.createElement(FlexBox, null,
                    React.createElement(SendProjectButton, { width: 187, disabled: (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) === 0 || (selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.length) > maxProjects, onClick: onSend }, t('competition.send')))),
            React.createElement(FlexBox, { width: '100%', direction: 'row', justify: 'space-between', align: 'center', offsetBottom: is1440BP ? 24 : 32 },
                isMobile ? MobileDropdownTabs : React.createElement(FlexBox, { gx: 24 }, Object.values(SEND_PROJECT_TABS).map(function (tab, index) { return React.createElement(ProjectTabItem, { isActive: activeTab == tab, key: index, onClick: function () { return setActiveTab(tab); } }, tabNames[tab]); })),
                searchBar),
            activeTab === SEND_PROJECT_TABS.find_projects && React.createElement(FlexBox, { width: "100%", offsetBottom: 24 },
                React.createElement(SearchInputComponent, { setSearchText: setSearchText, searchText: searchText, placeholder: "Введите ссылку на проект" })),
            isNoProjects ? React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(") : React.createElement(React.Fragment, null,
                React.createElement(ProjectsScroller, { isMobile: isMobile },
                    React.createElement(ProjectsGridNew, { isLoading: isProjectsLoading, columns: 4 }, (_b = projects === null || projects === void 0 ? void 0 : projects.data) === null || _b === void 0 ? void 0 : _b.map(function (v) {
                        var _a;
                        return (React.createElement(ProjectCardNew
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            project: v, identifier: v === null || v === void 0 ? void 0 : v.projectId, isModal: true, withoutGoToProject: true, isSelectable: true, key: v === null || v === void 0 ? void 0 : v.projectId, onSelect: onSelect, onProjectClick: undefined, metaAlwaysVisible: true, selected: selectedProjects === null || selectedProjects === void 0 ? void 0 : selectedProjects.includes((_a = v === null || v === void 0 ? void 0 : v.projectId) !== null && _a !== void 0 ? _a : '') }));
                    }))),
                React.createElement(Pagination, { pages: (_c = projectsPaging === null || projectsPaging === void 0 ? void 0 : projectsPaging.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                        // @ts-ignore
                        onPageChange(page);
                        setT(Date.now());
                        scrollTop();
                    }, isCanLoadMore: currentPage < ((_d = projectsPaging === null || projectsPaging === void 0 ? void 0 : projectsPaging.pages) !== null && _d !== void 0 ? _d : 0) })))));
};
export default SendProjectModal;
var templateObject_1, templateObject_2;
//# sourceMappingURL=SendProjectModal.js.map